var PRODUCT_SWATCH_COLORS_SELECTOR = '[data-algolia-swatch-colors]';
var MAX_SWATCHES = 5;
var SRCSET_WIDTHS_MOBILE = [180, 360, 540, 680];
var SRCSET_WIDTHS_DESKTOP = [720, 900, 1080, 1296, 1944, 2592, 3024];
function shopifyImageSrcUrl(src, width) {
  try {
    var url = new URL(src);
    url.searchParams.set('width', width);
    return url.toString();
  } catch (_) {
    return src.includes('?') ? "".concat(src, "&width=").concat(width) : "".concat(src, "?width=").concat(width);
  }
}
function shopifyImageSrcset(src, widths, imageWidth) {
  return widths.filter((w, i) => i === 0 || !imageWidth || imageWidth >= w).map(w => "".concat(shopifyImageSrcUrl(src, w), " ").concat(w, "w")).join(', ');
}
var productSwatchColorLookup;
function escapeHtml() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
function firstNonEmpty() {
  for (var i = 0; i < arguments.length; i += 1) {
    var value = i < 0 || arguments.length <= i ? undefined : arguments[i];
    if (value == null) continue;
    var stringValue = String(value).trim();
    if (stringValue) return stringValue;
  }
  return '';
}
function getThemeStrings() {
  var _window$theme;
  return ((_window$theme = window.theme) === null || _window$theme === void 0 ? void 0 : _window$theme.strings) || {};
}
function productCardUiStrings() {
  var strings = getThemeStrings();
  return {
    viewCta: String(strings.productCardViewCta || ''),
    regularPrice: String(strings.productCardRegularPrice || ''),
    sale: String(strings.productCardTagSale || ''),
    saleSr: String(strings.productCardBadgeSaleAria || ''),
    soldOut: String(strings.productCardSoldOutLabel || ''),
    soldOutSr: String(strings.productCardBadgeSoldOutAria || ''),
    lowStock: String(strings.productCardLowStockLabel || ''),
    lowStockSr: String(strings.productCardBadgeLowStockAria || ''),
    percentOff: String(strings.productCardPercentOff || '__PCT__% Off')
  };
}
function productCardPercentOffLabel(percent) {
  return productCardUiStrings().percentOff.replace(/__PCT__/g, String(percent));
}
function normalizeMoneyCents(value) {
  if (value == null || value === '') return 0;
  if (typeof value === 'number') {
    if (Number.isNaN(value)) return 0;
    if (!Number.isInteger(value)) return Math.round(value * 100);
    return value >= 1000 ? Math.round(value) : Math.round(value * 100);
  }
  var raw = String(value).trim().replace(/,/g, '');
  if (!raw) return 0;
  if (/^-?\d+\.\d+$/.test(raw)) {
    return Math.round(Number.parseFloat(raw) * 100);
  }
  var numeric = Number(raw);
  if (Number.isNaN(numeric)) return 0;
  if (/^-?\d+$/.test(raw) && raw.length > 3) {
    return Math.round(numeric);
  }
  return Math.round(numeric * 100);
}
function jsonForInlineScript(obj) {
  return JSON.stringify(obj).replace(/</g, '\\u003c');
}

/** `custom.swatch_data` JSON: `{ "Label": { "hex", "image" } }` → `{ color, image }` for cards. */
function readProductSwatchColorLookup() {
  var _el$textContent;
  if (productSwatchColorLookup) return productSwatchColorLookup;
  var el = document.querySelector(PRODUCT_SWATCH_COLORS_SELECTOR);
  var text = el === null || el === void 0 || (_el$textContent = el.textContent) === null || _el$textContent === void 0 ? void 0 : _el$textContent.trim();
  if (!text) {
    productSwatchColorLookup = {};
    return productSwatchColorLookup;
  }
  try {
    var parsed = JSON.parse(text);
    var normalized = {};
    Object.keys(parsed || {}).forEach(label => {
      var entry = parsed[label];
      if (entry && typeof entry === 'object') {
        var _ref, _entry$hex, _entry$image;
        normalized[label] = {
          color: String((_ref = (_entry$hex = entry.hex) !== null && _entry$hex !== void 0 ? _entry$hex : entry.color) !== null && _ref !== void 0 ? _ref : '').trim(),
          image: String((_entry$image = entry.image) !== null && _entry$image !== void 0 ? _entry$image : '').trim()
        };
        return;
      }
      normalized[label] = {
        color: String(entry !== null && entry !== void 0 ? entry : '').trim(),
        image: ''
      };
    });
    productSwatchColorLookup = normalized;
  } catch (_unused) {
    productSwatchColorLookup = {};
  }
  return productSwatchColorLookup;
}
function productVariants(product) {
  return Array.isArray(product === null || product === void 0 ? void 0 : product.variants) ? product.variants : [];
}
function selectedVariant(product) {
  var _product$selected_var;
  var selected = product === null || product === void 0 ? void 0 : product.selected_variant;
  if (selected && typeof selected === 'object') return selected;
  var variants = productVariants(product);
  var selectedId = String((_product$selected_var = product === null || product === void 0 ? void 0 : product.selected_variant_id) !== null && _product$selected_var !== void 0 ? _product$selected_var : '');
  if (selectedId) {
    var matchedVariant = variants.find(variant => {
      var _variant$id;
      return String((_variant$id = variant === null || variant === void 0 ? void 0 : variant.id) !== null && _variant$id !== void 0 ? _variant$id : '') === selectedId;
    });
    if (matchedVariant) return matchedVariant;
  }
  return variants[0] || null;
}
function variantHiddenFromStore(variant) {
  var _variant$metafields$c, _variant$metafields, _variant$metafields2;
  var val = (_variant$metafields$c = variant === null || variant === void 0 || (_variant$metafields = variant.metafields) === null || _variant$metafields === void 0 || (_variant$metafields = _variant$metafields.content) === null || _variant$metafields === void 0 || (_variant$metafields = _variant$metafields.hidden_from_online_store) === null || _variant$metafields === void 0 ? void 0 : _variant$metafields.value) !== null && _variant$metafields$c !== void 0 ? _variant$metafields$c : variant === null || variant === void 0 || (_variant$metafields2 = variant.metafields) === null || _variant$metafields2 === void 0 || (_variant$metafields2 = _variant$metafields2.content) === null || _variant$metafields2 === void 0 ? void 0 : _variant$metafields2.hidden_from_online_store;
  return val === true || val === 'true';
}
function variantAvailable(variant) {
  var _variant$inventory_po, _variant$inventory_qu;
  if (!variant) return false;
  if (typeof variant.available === 'boolean') return variant.available;
  var inventoryPolicy = String((_variant$inventory_po = variant.inventory_policy) !== null && _variant$inventory_po !== void 0 ? _variant$inventory_po : '').toLowerCase();
  if (inventoryPolicy === 'continue') return true;
  if (!variant.inventory_management) return true;
  return Number((_variant$inventory_qu = variant.inventory_quantity) !== null && _variant$inventory_qu !== void 0 ? _variant$inventory_qu : 0) > 0;
}
function productUrl(product) {
  var explicitUrl = firstNonEmpty(product === null || product === void 0 ? void 0 : product.url);
  if (explicitUrl) return explicitUrl;
  var handle = firstNonEmpty(product === null || product === void 0 ? void 0 : product.handle);
  if (handle) return "/products/".concat(handle);
  return '#';
}
function normalizeImageCandidate(candidate) {
  var _candidate$featured_m, _candidate$featured_m2, _ref2, _ref3, _ref4, _candidate$id, _ref5, _ref6, _ref7, _candidate$width, _ref8, _ref9, _ref0, _candidate$height;
  if (!candidate) return null;
  if (typeof candidate === 'string') {
    var _src = candidate.trim();
    return _src ? {
      src: _src
    } : null;
  }
  if (typeof candidate !== 'object') return null;
  var nestedImage = normalizeImageCandidate(candidate.image);
  var nestedFeaturedImage = normalizeImageCandidate(candidate.featured_image);
  var nestedPreviewImage = normalizeImageCandidate(candidate.preview_image);
  var nestedMediaImage = normalizeImageCandidate((_candidate$featured_m = candidate.featured_media) === null || _candidate$featured_m === void 0 ? void 0 : _candidate$featured_m.preview_image);
  var src = firstNonEmpty(candidate.src, candidate.url, candidate.image_url, candidate.featured_image_url, (_candidate$featured_m2 = candidate.featured_media) === null || _candidate$featured_m2 === void 0 ? void 0 : _candidate$featured_m2.src, nestedImage === null || nestedImage === void 0 ? void 0 : nestedImage.src, nestedFeaturedImage === null || nestedFeaturedImage === void 0 ? void 0 : nestedFeaturedImage.src, nestedPreviewImage === null || nestedPreviewImage === void 0 ? void 0 : nestedPreviewImage.src, nestedMediaImage === null || nestedMediaImage === void 0 ? void 0 : nestedMediaImage.src);
  if (!src) return null;
  return {
    id: (_ref2 = (_ref3 = (_ref4 = (_candidate$id = candidate.id) !== null && _candidate$id !== void 0 ? _candidate$id : nestedImage === null || nestedImage === void 0 ? void 0 : nestedImage.id) !== null && _ref4 !== void 0 ? _ref4 : nestedFeaturedImage === null || nestedFeaturedImage === void 0 ? void 0 : nestedFeaturedImage.id) !== null && _ref3 !== void 0 ? _ref3 : nestedPreviewImage === null || nestedPreviewImage === void 0 ? void 0 : nestedPreviewImage.id) !== null && _ref2 !== void 0 ? _ref2 : null,
    src,
    width: (_ref5 = (_ref6 = (_ref7 = (_candidate$width = candidate.width) !== null && _candidate$width !== void 0 ? _candidate$width : nestedImage === null || nestedImage === void 0 ? void 0 : nestedImage.width) !== null && _ref7 !== void 0 ? _ref7 : nestedFeaturedImage === null || nestedFeaturedImage === void 0 ? void 0 : nestedFeaturedImage.width) !== null && _ref6 !== void 0 ? _ref6 : nestedPreviewImage === null || nestedPreviewImage === void 0 ? void 0 : nestedPreviewImage.width) !== null && _ref5 !== void 0 ? _ref5 : null,
    height: (_ref8 = (_ref9 = (_ref0 = (_candidate$height = candidate.height) !== null && _candidate$height !== void 0 ? _candidate$height : nestedImage === null || nestedImage === void 0 ? void 0 : nestedImage.height) !== null && _ref0 !== void 0 ? _ref0 : nestedFeaturedImage === null || nestedFeaturedImage === void 0 ? void 0 : nestedFeaturedImage.height) !== null && _ref9 !== void 0 ? _ref9 : nestedPreviewImage === null || nestedPreviewImage === void 0 ? void 0 : nestedPreviewImage.height) !== null && _ref8 !== void 0 ? _ref8 : null,
    alt: firstNonEmpty(candidate.alt, nestedImage === null || nestedImage === void 0 ? void 0 : nestedImage.alt, nestedFeaturedImage === null || nestedFeaturedImage === void 0 ? void 0 : nestedFeaturedImage.alt, nestedPreviewImage === null || nestedPreviewImage === void 0 ? void 0 : nestedPreviewImage.alt)
  };
}
function productImages(product) {
  var images = Array.isArray(product === null || product === void 0 ? void 0 : product.images) ? product.images.map(normalizeImageCandidate).filter(Boolean) : [];
  if (images.length > 0) return images;
  var fallbackImages = [normalizeImageCandidate(product === null || product === void 0 ? void 0 : product.featured_image), normalizeImageCandidate(product === null || product === void 0 ? void 0 : product.image)].filter(Boolean);
  if (fallbackImages.length > 0) return fallbackImages;
  return [];
}
function imageSrc(image) {
  var _normalizeImageCandid;
  return ((_normalizeImageCandid = normalizeImageCandidate(image)) === null || _normalizeImageCandid === void 0 ? void 0 : _normalizeImageCandid.src) || '';
}
function primaryImage(product, variant) {
  var _variant$featured_med, _ref1, _ref10, _ref11, _variant$image_id, _variant$image, _variant$featured_ima, _product$featured_ima, _product$image;
  var images = productImages(product);
  var directVariantImage = normalizeImageCandidate((variant === null || variant === void 0 || (_variant$featured_med = variant.featured_media) === null || _variant$featured_med === void 0 ? void 0 : _variant$featured_med.preview_image) || (variant === null || variant === void 0 ? void 0 : variant.featured_image) || (variant === null || variant === void 0 ? void 0 : variant.image) || (variant === null || variant === void 0 ? void 0 : variant.image_url));
  if (directVariantImage) return directVariantImage;
  var directProductImage = normalizeImageCandidate((product === null || product === void 0 ? void 0 : product.featured_image) || (product === null || product === void 0 ? void 0 : product.image));
  var primaryId = (_ref1 = (_ref10 = (_ref11 = (_variant$image_id = variant === null || variant === void 0 ? void 0 : variant.image_id) !== null && _variant$image_id !== void 0 ? _variant$image_id : variant === null || variant === void 0 || (_variant$image = variant.image) === null || _variant$image === void 0 ? void 0 : _variant$image.id) !== null && _ref11 !== void 0 ? _ref11 : variant === null || variant === void 0 || (_variant$featured_ima = variant.featured_image) === null || _variant$featured_ima === void 0 ? void 0 : _variant$featured_ima.id) !== null && _ref10 !== void 0 ? _ref10 : product === null || product === void 0 || (_product$featured_ima = product.featured_image) === null || _product$featured_ima === void 0 ? void 0 : _product$featured_ima.id) !== null && _ref1 !== void 0 ? _ref1 : product === null || product === void 0 || (_product$image = product.image) === null || _product$image === void 0 ? void 0 : _product$image.id;
  if (primaryId != null) {
    var matchedImage = images.find(image => {
      var _image$id;
      return String((_image$id = image === null || image === void 0 ? void 0 : image.id) !== null && _image$id !== void 0 ? _image$id : '') === String(primaryId);
    });
    if (matchedImage) return matchedImage;
  }
  return directProductImage || images[0] || null;
}
function hoverImage(product, heroImage) {
  var _heroImage$id;
  var images = productImages(product);
  if (!heroImage) return images[1] || null;
  var heroId = String((_heroImage$id = heroImage === null || heroImage === void 0 ? void 0 : heroImage.id) !== null && _heroImage$id !== void 0 ? _heroImage$id : '');
  var heroIndex = images.findIndex(image => {
    var _image$id2;
    return String((_image$id2 = image === null || image === void 0 ? void 0 : image.id) !== null && _image$id2 !== void 0 ? _image$id2 : '') === heroId;
  });
  if (heroIndex >= 0 && heroIndex + 1 < images.length) {
    return images[heroIndex + 1];
  }
  return heroIndex === -1 ? images[1] || null : null;
}
function productDisplayTitle(product) {
  var _product$metafields, _product$metafields2;
  return firstNonEmpty(product === null || product === void 0 || (_product$metafields = product.metafields) === null || _product$metafields === void 0 || (_product$metafields = _product$metafields.content) === null || _product$metafields === void 0 || (_product$metafields = _product$metafields.product_name_override) === null || _product$metafields === void 0 ? void 0 : _product$metafields.value, product === null || product === void 0 || (_product$metafields2 = product.metafields) === null || _product$metafields2 === void 0 || (_product$metafields2 = _product$metafields2.content) === null || _product$metafields2 === void 0 ? void 0 : _product$metafields2.product_name_override, product === null || product === void 0 ? void 0 : product.title);
}
function variantCapacity(variant, product) {
  var _variant$metafields3, _product$metafields3;
  return firstNonEmpty(variant === null || variant === void 0 ? void 0 : variant.capacity, variant === null || variant === void 0 || (_variant$metafields3 = variant.metafields) === null || _variant$metafields3 === void 0 || (_variant$metafields3 = _variant$metafields3.content) === null || _variant$metafields3 === void 0 || (_variant$metafields3 = _variant$metafields3.capacity) === null || _variant$metafields3 === void 0 ? void 0 : _variant$metafields3.value, product === null || product === void 0 || (_product$metafields3 = product.metafields) === null || _product$metafields3 === void 0 || (_product$metafields3 = _product$metafields3.content) === null || _product$metafields3 === void 0 || (_product$metafields3 = _product$metafields3.capacity) === null || _product$metafields3 === void 0 ? void 0 : _product$metafields3.value);
}
function variantPromoMessage(variant) {
  var _variant$metafields4, _variant$metafields5;
  return firstNonEmpty(variant === null || variant === void 0 ? void 0 : variant.promo_message, variant === null || variant === void 0 || (_variant$metafields4 = variant.metafields) === null || _variant$metafields4 === void 0 || (_variant$metafields4 = _variant$metafields4.content) === null || _variant$metafields4 === void 0 || (_variant$metafields4 = _variant$metafields4.promo_message) === null || _variant$metafields4 === void 0 ? void 0 : _variant$metafields4.value, variant === null || variant === void 0 || (_variant$metafields5 = variant.metafields) === null || _variant$metafields5 === void 0 || (_variant$metafields5 = _variant$metafields5.content) === null || _variant$metafields5 === void 0 ? void 0 : _variant$metafields5.promo_message);
}
function variantManualBadge(variant) {
  var _variant$metafields6, _variant$metafields7;
  return firstNonEmpty(variant === null || variant === void 0 ? void 0 : variant.manual_text_badge, variant === null || variant === void 0 ? void 0 : variant.manual_badge, variant === null || variant === void 0 || (_variant$metafields6 = variant.metafields) === null || _variant$metafields6 === void 0 || (_variant$metafields6 = _variant$metafields6.content) === null || _variant$metafields6 === void 0 || (_variant$metafields6 = _variant$metafields6.manual_text_badge) === null || _variant$metafields6 === void 0 ? void 0 : _variant$metafields6.value, variant === null || variant === void 0 || (_variant$metafields7 = variant.metafields) === null || _variant$metafields7 === void 0 || (_variant$metafields7 = _variant$metafields7.content) === null || _variant$metafields7 === void 0 ? void 0 : _variant$metafields7.manual_text_badge);
}
function variantBadgeIcon(variant) {
  var _variant$metafields8, _metafieldIcon$image, _metafieldIcon$image2;
  var metafieldIcon = variant === null || variant === void 0 || (_variant$metafields8 = variant.metafields) === null || _variant$metafields8 === void 0 || (_variant$metafields8 = _variant$metafields8.content) === null || _variant$metafields8 === void 0 || (_variant$metafields8 = _variant$metafields8.badge_icon) === null || _variant$metafields8 === void 0 ? void 0 : _variant$metafields8.value;
  return {
    url: firstNonEmpty(variant === null || variant === void 0 ? void 0 : variant.badge_icon_url, metafieldIcon === null || metafieldIcon === void 0 ? void 0 : metafieldIcon.src, metafieldIcon === null || metafieldIcon === void 0 ? void 0 : metafieldIcon.url, metafieldIcon === null || metafieldIcon === void 0 || (_metafieldIcon$image = metafieldIcon.image) === null || _metafieldIcon$image === void 0 ? void 0 : _metafieldIcon$image.src),
    alt: firstNonEmpty(variant === null || variant === void 0 ? void 0 : variant.badge_icon_alt, metafieldIcon === null || metafieldIcon === void 0 ? void 0 : metafieldIcon.alt, metafieldIcon === null || metafieldIcon === void 0 || (_metafieldIcon$image2 = metafieldIcon.image) === null || _metafieldIcon$image2 === void 0 ? void 0 : _metafieldIcon$image2.alt)
  };
}
function badgeInfo(variant) {
  var _variant$inventory_qu2;
  var ui = productCardUiStrings();
  var manualBadge = variantManualBadge(variant);
  var price = normalizeMoneyCents(variant === null || variant === void 0 ? void 0 : variant.price);
  var compareAt = normalizeMoneyCents(variant === null || variant === void 0 ? void 0 : variant.compare_at_price);
  var available = variantAvailable(variant);
  var inventoryQuantity = Number((_variant$inventory_qu2 = variant === null || variant === void 0 ? void 0 : variant.inventory_quantity) !== null && _variant$inventory_qu2 !== void 0 ? _variant$inventory_qu2 : 0);
  var hasManagedInventory = Boolean(variant === null || variant === void 0 ? void 0 : variant.inventory_management);
  if (manualBadge) {
    return {
      kind: 'manual',
      text: manualBadge,
      sr: manualBadge,
      modifier: 'manual'
    };
  }
  if (compareAt > price) {
    return {
      kind: 'sale',
      text: ui.sale,
      sr: ui.saleSr,
      modifier: 'sale'
    };
  }
  if (!available) {
    return {
      kind: 'sold_out',
      text: ui.soldOut,
      sr: ui.soldOutSr,
      modifier: 'sold-out'
    };
  }
  if (hasManagedInventory && inventoryQuantity <= 10) {
    return {
      kind: 'low_inventory',
      text: ui.lowStock,
      sr: ui.lowStockSr,
      modifier: 'low-stock'
    };
  }
  return {
    kind: 'none',
    text: '',
    sr: '',
    modifier: ''
  };
}
function pictureSpec(image, alt) {
  var src = imageSrc(image);
  if (!src) return null;
  var imageWidth = (image === null || image === void 0 ? void 0 : image.width) || null;
  var mSrcset = shopifyImageSrcset(src, SRCSET_WIDTHS_MOBILE, imageWidth);
  var dSrcset = shopifyImageSrcset(src, SRCSET_WIDTHS_DESKTOP, imageWidth);
  return {
    src,
    srcset: "".concat(mSrcset, ", ").concat(dSrcset),
    dSrcset,
    mSrcset,
    media: '(min-width: 681px)',
    w: imageWidth || 1,
    h: (image === null || image === void 0 ? void 0 : image.height) || 1,
    alt: alt || ''
  };
}
function variantPayload(product, variant) {
  var _variant$id2, _variant$inventory_qu3, _variant$inventory_ma;
  var alt = productDisplayTitle(product);
  var heroImage = primaryImage(product, variant);
  var secondaryImage = hoverImage(product, heroImage);
  var icon = variantBadgeIcon(variant);
  var badge = badgeInfo(variant);
  var price = normalizeMoneyCents(variant === null || variant === void 0 ? void 0 : variant.price);
  var compareAt = normalizeMoneyCents(variant === null || variant === void 0 ? void 0 : variant.compare_at_price);
  var base = productUrl(product);
  var url = variant !== null && variant !== void 0 && variant.id ? "".concat(base, "?variant=").concat(variant.id) : base;
  return {
    id: (_variant$id2 = variant === null || variant === void 0 ? void 0 : variant.id) !== null && _variant$id2 !== void 0 ? _variant$id2 : '',
    url,
    capacity: variantCapacity(variant, product),
    price,
    compareAtPrice: compareAt > price ? compareAt : null,
    available: variantAvailable(variant),
    inventoryQuantity: (_variant$inventory_qu3 = variant === null || variant === void 0 ? void 0 : variant.inventory_quantity) !== null && _variant$inventory_qu3 !== void 0 ? _variant$inventory_qu3 : null,
    inventoryManagement: (_variant$inventory_ma = variant === null || variant === void 0 ? void 0 : variant.inventory_management) !== null && _variant$inventory_ma !== void 0 ? _variant$inventory_ma : null,
    promo: variantPromoMessage(variant),
    iconUrl: icon.url,
    iconAlt: icon.alt,
    badgeKind: badge.kind,
    badgeText: badge.text,
    badgeSr: badge.sr,
    badgeModifier: badge.modifier,
    primary: pictureSpec(heroImage, alt),
    hover: secondaryImage ? pictureSpec(secondaryImage, alt) : null
  };
}
function variantsPayload(product) {
  var variants = productVariants(product).filter(v => !variantHiddenFromStore(v));
  var selected = selectedVariant(product);
  var map = {};
  variants.forEach(variant => {
    if (!(variant !== null && variant !== void 0 && variant.id)) return;
    map[String(variant.id)] = variantPayload(product, variant);
  });
  if (Object.keys(map).length === 0 && selected !== null && selected !== void 0 && selected.id) {
    map[String(selected.id)] = variantPayload(product, selected);
  }
  return {
    variants: map
  };
}
function swatchLookupForValue(value) {
  var lookup = readProductSwatchColorLookup();
  return lookup[String(value).trim()] || {};
}
function variantsForSwatchValue(variants, value) {
  return variants.filter(variant => {
    var _variant$option;
    return String((_variant$option = variant === null || variant === void 0 ? void 0 : variant.option1) !== null && _variant$option !== void 0 ? _variant$option : '') === String(value) && !variantHiddenFromStore(variant);
  });
}
function representativeVariantForSwatchValue(variants, value, activeVariant) {
  var _activeVariant$id;
  var matchingVariants = variantsForSwatchValue(variants, value);
  if (matchingVariants.length === 0) return null;
  var activeVariantId = String((_activeVariant$id = activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.id) !== null && _activeVariant$id !== void 0 ? _activeVariant$id : '');
  if (activeVariantId) {
    var activeMatch = matchingVariants.find(variant => {
      var _variant$id3;
      return String((_variant$id3 = variant === null || variant === void 0 ? void 0 : variant.id) !== null && _variant$id3 !== void 0 ? _variant$id3 : '') === activeVariantId;
    });
    if (activeMatch) return activeMatch;
  }
  var firstAvailableVariant = matchingVariants.find(variantAvailable);
  return firstAvailableVariant || matchingVariants[0];
}
function swatchValueAvailable(variants, value) {
  return variantsForSwatchValue(variants, value).some(variantAvailable);
}
function renderSwatches(product, activeVariant) {
  var options = Array.isArray(product === null || product === void 0 ? void 0 : product.options) ? product.options : [];
  var colorOption = options[0];
  var values = Array.isArray(colorOption === null || colorOption === void 0 ? void 0 : colorOption.values) ? colorOption.values : [];
  var variants = productVariants(product);
  var publishedValues = values.filter(value => {
    var _representativeVarian;
    return (_representativeVarian = representativeVariantForSwatchValue(variants, value, activeVariant)) === null || _representativeVarian === void 0 ? void 0 : _representativeVarian.id;
  });
  if (publishedValues.length === 0) {
    return '<div class="card__color-swatches" data-card-color-swatches hidden></div>';
  }
  var visibleSwatchCount = 0;
  var inner = publishedValues.map(value => {
    var _activeVariant$option, _activeVariant$id2;
    if (visibleSwatchCount >= MAX_SWATCHES) return '';
    var variantForSwatch = representativeVariantForSwatchValue(variants, value, activeVariant);
    if (!(variantForSwatch !== null && variantForSwatch !== void 0 && variantForSwatch.id)) return '';
    visibleSwatchCount += 1;
    var selected = String((_activeVariant$option = activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.option1) !== null && _activeVariant$option !== void 0 ? _activeVariant$option : '') === String(value) || String(variantForSwatch.id) === String((_activeVariant$id2 = activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.id) !== null && _activeVariant$id2 !== void 0 ? _activeVariant$id2 : '');
    var unavailable = !swatchValueAvailable(variants, value);
    var swatchMeta = swatchLookupForValue(value);
    var swatchColor = firstNonEmpty(variantForSwatch === null || variantForSwatch === void 0 ? void 0 : variantForSwatch.swatch_color, swatchMeta.color);
    var swatchImage = firstNonEmpty(variantForSwatch === null || variantForSwatch === void 0 ? void 0 : variantForSwatch.swatch_image, swatchMeta.image);
    var style = [swatchColor ? "background-color:".concat(escapeHtml(swatchColor), ";") : '', swatchImage ? "background-image:url(".concat(escapeHtml(swatchImage), ");") : ''].join('');
    var safeValue = escapeHtml(value);
    var disabledClass = unavailable ? ' card__swatch--disabled' : '';
    var imageClass = swatchImage ? ' card__swatch--color-option--image' : '';
    var selectedClass = selected ? ' selected' : '';
    var unavailableLabel = unavailable ? "".concat(safeValue, ", ").concat(escapeHtml(productCardUiStrings().soldOutSr)) : safeValue;
    return "\n                <div\n                    class=\"card__swatch--color-option".concat(imageClass).concat(selectedClass).concat(disabledClass, "\"\n                    data-swatch=\"").concat(safeValue, "\"\n                    data-variant-id=\"").concat(escapeHtml(String(variantForSwatch.id)), "\"\n                    ").concat(unavailable ? 'data-swatch-unavailable="true"' : '', "\n                    role=\"button\"\n                    tabindex=\"0\"\n                    aria-disabled=\"false\"\n                    aria-label=\"").concat(unavailableLabel, "\"\n                >\n                    <span class=\"card__swatch-option-label\">\n                        <span class=\"card__swatch-option-label-inner").concat(swatchImage ? ' card__swatch-option-label-inner--image' : '', "\"").concat(style ? " style=\"".concat(style, "\"") : '', "></span>\n                        <span class=\"card__swatch-option-label-visually-hidden\">").concat(safeValue, "</span>\n                    </span>\n                </div>");
  }).join('');
  var remaining = publishedValues.length - visibleSwatchCount;
  var more = remaining > 0 ? "<div class=\"card__more-colors-link\"><a href=\"".concat(escapeHtml(productUrl(product)), "\">+").concat(remaining, "</a></div>") : '';
  return "<div class=\"card__color-swatches\" data-card-color-swatches><div class=\"card__color-swatches__inner\">".concat(inner, "</div>").concat(more, "</div>");
}
function productId(product) {
  var _ref12, _product$id;
  var productIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return String((_ref12 = (_product$id = product === null || product === void 0 ? void 0 : product.id) !== null && _product$id !== void 0 ? _product$id : product === null || product === void 0 ? void 0 : product.handle) !== null && _ref12 !== void 0 ? _ref12 : "rebuy-".concat(productIndex));
}
function titleId(product) {
  var productIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return "product-card__title-".concat(productId(product, productIndex));
}
function capacity(product) {
  return variantCapacity(selectedVariant(product), product);
}
function hasCapacity(product) {
  return capacity(product) !== '';
}
function subtitle(product) {
  return product === null || product === void 0 ? void 0 : product.product_type;
}
function linkLabel(product) {
  return productDisplayTitle(product);
}
function productBadge(product) {
  return badgeInfo(selectedVariant(product));
}
function productIcon(product) {
  return variantBadgeIcon(selectedVariant(product));
}
function promo(product) {
  return variantPromoMessage(selectedVariant(product));
}
function hasPromo(product) {
  return promo(product) !== '';
}
function productOnSale(product) {
  var variant = selectedVariant(product);
  var price = normalizeMoneyCents(variant === null || variant === void 0 ? void 0 : variant.price);
  var compareAt = normalizeMoneyCents(variant === null || variant === void 0 ? void 0 : variant.compare_at_price);
  return compareAt > price;
}
function discountLabel(product) {
  if (!productOnSale(product)) return '';
  var variant = selectedVariant(product);
  var price = normalizeMoneyCents(variant === null || variant === void 0 ? void 0 : variant.price);
  var compareAt = normalizeMoneyCents(variant === null || variant === void 0 ? void 0 : variant.compare_at_price);
  if (compareAt <= 0) return '';
  var salePercent = Math.round((1 - price / compareAt) * 100);
  return salePercent > 0 ? productCardPercentOffLabel(salePercent) : '';
}
function hoverImageUrl(product) {
  var variant = selectedVariant(product);
  var heroImage = primaryImage(product, variant);
  return imageSrc(hoverImage(product, heroImage));
}
function hasHoverImage(product) {
  return hoverImageUrl(product) !== '';
}
function variantsJson(product) {
  return jsonForInlineScript(variantsPayload(product));
}
function activeVariant(product) {
  return selectedVariant(product);
}
window.iamotaRebuyCard = {
  viewCta: productCardUiStrings().viewCta,
  regularPrice: productCardUiStrings().regularPrice,
  activeVariant,
  titleId,
  productId,
  displayTitle: productDisplayTitle,
  subtitle,
  capacity,
  hasCapacity,
  linkLabel,
  productBadge,
  productIcon,
  promo,
  hasPromo,
  discountLabel,
  hoverImageUrl,
  hasHoverImage,
  primaryImageSpec(product) {
    var variant = selectedVariant(product);
    var hero = primaryImage(product, variant);
    var alt = productDisplayTitle(product);
    return pictureSpec(hero, alt) || {
      src: '',
      srcset: '',
      dSrcset: '',
      mSrcset: '',
      alt: ''
    };
  },
  hoverImageSpec(product) {
    var variant = selectedVariant(product);
    var hero = primaryImage(product, variant);
    var hover = hoverImage(product, hero);
    if (!hover) return null;
    var alt = productDisplayTitle(product);
    return pictureSpec(hover, alt);
  },
  swatchesHtml(product) {
    return renderSwatches(product, selectedVariant(product));
  },
  variantsJson,
  variantUrl(product) {
    var variant = selectedVariant(product);
    var base = productUrl(product);
    if (!(variant !== null && variant !== void 0 && variant.id)) return base;
    return "".concat(base, "?variant=").concat(variant.id);
  }
};